import { Domains } from "@/core/types/types";

function getHostNameForEnv(host: string) {
  const isTest = process.env.NODE_ENV === "test";
  const isBrowser: boolean = typeof window !== "undefined";

  if (isTest) return host;
  if (isBrowser) return window.location.hostname;
  return host;
}

const getTopLevelDomain = (host: string = ""): Domains | string => {
  const hostname: string = getHostNameForEnv(host);
  const isLocalhost: boolean = hostname.indexOf("localhost") === 0;

  const fullTld: string = isLocalhost
    ? Domains.NET
    : hostname.slice(hostname.lastIndexOf(".") + 1, hostname.length);

  // Slice the port `:3000` from hostname for local development
  const tld: Domains | string =
    fullTld.lastIndexOf(":") === -1
      ? fullTld
      : fullTld.slice(0, fullTld.lastIndexOf(":"));

  return tld;
};

export default getTopLevelDomain;
